var _circle, _circle2, _circle3, _circle4, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchangeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#232123"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#232123"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 25,
    fill: "#232123"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 25,
    fill: "#1086DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8959 19.9102L16.8183 29.2392C16.504 29.7217 16.8505 30.3602 17.4268 30.3602L20.3932 30.3602L20.3932 33.6123C20.3932 39.7258 25.3536 44.6819 31.4723 44.6819C32.001 44.6819 32.4297 44.2536 32.4297 43.7254L32.4297 39.4213C32.4297 38.8931 32.001 38.4648 31.4723 38.4648C28.7899 38.4648 26.6157 36.2922 26.6157 33.6123L26.6157 30.3602L29.5821 30.3602C30.1584 30.3602 30.5049 29.7217 30.1906 29.2392L24.113 19.9102C23.8266 19.4707 23.1825 19.4707 22.8961 19.9102L22.8959 19.9102Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0007 44.3521L48.0785 35.0231C48.3929 34.5406 48.0464 33.9021 47.4701 33.9021L44.5036 33.9021L44.5036 30.6499C44.5036 24.5367 39.5433 19.5806 33.4245 19.5806C32.8959 19.5806 32.4672 20.0089 32.4672 20.5371L32.4672 24.8412C32.4672 25.3694 32.8959 25.7977 33.4245 25.7977C36.1069 25.7977 38.2812 27.9703 38.2812 30.6502L38.2812 33.9023L35.3147 33.9023C34.7385 33.9023 34.392 34.5408 34.7063 35.0233L40.7838 44.3523C41.0702 44.7918 41.7143 44.7918 42.0007 44.3523L42.0007 44.3521Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/exchangeIcon.2463c8d2436dd34584f5947c3022c039.svg";
export { ForwardRef as ReactComponent };